import { Injectable } from '@angular/core';
import { Subject, Observable } from "rxjs/Rx";

@Injectable()
export class BusyLoaderService {
    LoadingText: Subject<string>;
    NextLoadingObservable: Subject<Observable<any>>;

    constructor() {
        this.LoadingText = new Subject<string>();
        this.NextLoadingObservable = new Subject<Observable<any>>();
    }

    SetLoadingText(val: string = "Loading") {
        this.LoadingText.next(val);
    }

    AddLoadingObservable(ob: Observable<any>) {
        this.NextLoadingObservable.next(ob);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/busy-loader.service.ts